export const OPERATION = {
    LIST: 'LIST',
    ADD: 'ADD',
    READ: 'READ',
    EDIT: 'EDIT',
    DELETE: 'DELETE'
};

export default OPERATION;


// WEBPACK FOOTER //
// ./src/utils/constants.js